import React, { Component } from "react"

import MetaTags from "react-meta-tags"
import CarouselPage from "./CarouselPage"

// import images
import logodark from "../../assets/images/logo-dark.png"
import logolight from "../../assets/images/logo-light.png"
import { Col, Container, Row } from "reactstrap"
import { Link } from "react-router-dom"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { activateUser } from "../../store/actions"

class UserActivation extends Component {
  componentDidMount() {
    const {
      match: { params },
    } = this.props
    if (params && params.token) {
      console.log("params.token : ")
      console.log(params.token)
      this.props.activateUser(params.token)
    }
  }

  render() {
    const { loading } = this.props
    if (loading) {
      return null
    } else {
      return (
        <React.Fragment>
          <div>
            <MetaTags>
              <title>User Activation | Kattam</title>
            </MetaTags>
            <Container fluid className="p-0">
              <Row className="g-0">
                <CarouselPage />

                <Col cl={3}>
                  <div className="auth-full-page-content p-md-5 p-4">
                    <div className="w-100">
                      <div className="d-flex flex-column h-100">
                        <div className="mb-4 mb-md-5">
                          <a href="/" className="d-block auth-logo">
                            <img
                              src={logodark}
                              alt=""
                              height="80"
                              className="auth-logo-dark"
                            />
                            <img
                              src={logolight}
                              alt=""
                              height="18"
                              className="auth-logo-light"
                            />
                          </a>
                        </div>
                        <div className="my-auto">
                          <div className="text-center">
                            {this.props.activationError &&
                              this.props.activationError ? (
                              <div>
                                <h4 className="text-danger mb-md-4">
                                  Account activation Failed!!!
                                </h4>
                                <div className="avatar-md mx-auto mb-md-4">
                                  {/* <div className="avatar-title rounded-circle bg-light">
                                    <i className="bx bx-x h1 mb-0 text-danger"></i>
                                  </div> */}
                                  <i className="mdi mdi-close-circle-outline text-danger display-4" />
                                </div>
                                <p className="text-muted mb-0">
                                  Please contact{" "}
                                  <Link
                                    to="mailto:info@kattam.ai"
                                    className="text-decoration-underline"
                                  >
                                  info@kattam.ai
                                  </Link>
                                </p>
                              </div>
                            ) : (
                              <div>
                                <h4 className="text-success mb-4">
                                  {this.props.activation}
                                </h4>
                                <div className="avatar-md mx-auto mb-4">
                                  {/* <div className="avatar-title rounded-circle bg-light">
                                    <i className="bx bx-check h1 mb-0 text-success"></i>
                                  </div> */}
                                  <i className="mdi mdi-check-circle-outline text-success display-4" />
                                </div>
                                <p>
                                  Click here to{" "}
                                  <Link
                                    to="/login"
                                    className="fw-medium text-primary"
                                  >
                                    {" "}
                                    Login
                                  </Link>{" "}
                                </p>
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="mt-4 mt-md-5 text-center">
                          <p className="mb-0">
                            © {new Date().getFullYear()} Kattam. All rights
                            reserved{" "}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>
            </Container>
          </div>
        </React.Fragment>
      )
    }
  }
}

UserActivation.propTypes = {
  activateUser: PropTypes.func,
  activationError: PropTypes.any,
  activation: PropTypes.object,
}

const mapStateToProps = state => {
  const { activation, activationError, loading } = state.Account
  return { activation, activationError, loading }
}

export default connect(mapStateToProps, { activateUser })(UserActivation)
